import { useStore } from '~/store';
import { isArray } from '~/libs/shared/utils/src/Common/Common';

export default defineNuxtRouteMiddleware(async (to, from) => {
  const segments = to.path.split('/');
  const locale = segments[1] || 'en';
  const store = useStore();

  store.setLoading(true);

  if (store.$state.pageConfig) {
    store.resetPageConfig();
  }

  const { data, error } = await useAsyncData('pageConfig', () =>
    $fetch(`/${locale}/${to.params.category}/${to.params.slug}/api/project`)
  ).finally(() => {
    store.setLoading(false);
  });

  if (error.value) {
    console.error('Error fetching page config:', error.value);
    return abortNavigation();
  }

  if (!data.value || !data.value.id || !isArray(data.value.blocks)) {
    console.log('error');

    try {
      if (locale === 'ar') {
        if (import.meta.client) {
          window.location.href = to.path.replace('/ar/', '/en/');
        } else {
          return navigateTo(to.path.replace('/ar/', '/en/'), { external: true });
        }
      }
    } catch (e) {
      console.log(e);
    }

    return createError({ statusCode: 404, message: 'Page not found' });
  } else {
    store.setPageConfig(data.value);
  }
});
